import { ComponentType, useContext } from 'react';
import {
  LinkProps,
  Link as RouterLink,
  NavLink as RouterNavLink,
} from 'react-router-dom';

import { TrackedLink } from 'components/Link/TrackedLink';
import { UpdateRequiredContext } from 'containers/UpdateRequiredContext';

type Props = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: ComponentType<any>;
  to: LinkProps['to'];
  state?: LinkProps['state'];
} & Record<string, unknown>;

export function BaseLink({ component, to, state, ...props }: Props) {
  const Component = component;

  const updateRequired = useContext(UpdateRequiredContext);

  if (updateRequired && typeof to === 'string' && !state) {
    return (
      <TrackedLink
        href={to}
        eventName="Updating App Version"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    );
  }

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component to={to} state={state} {...props} />;
}

export function NavLink({ to, state, ...props }: Omit<Props, 'component'>) {
  return (
    // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'To'.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <BaseLink component={RouterNavLink} to={to} state={state} {...props} />
  );
}

export function Link({ to, state, ...props }: Omit<Props, 'component'>) {
  // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'To'.
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <BaseLink component={RouterLink} to={to} state={state} {...props} />;
}
